/* VIVIASKIN bloom — layered petal drift, parallax, self-drawing branches,
   blossom bursts, and product-hover petals (experiment) */
(function () {
  var PETAL_SVG =
    '<svg viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 1 C15.5 4.5 18.5 11 10 23 C1.5 11 4.5 4.5 10 1 Z"/>' +
    '</svg>';

  var TONES = [];
  [
    { fill: 'rgba(255,255,255,0.95)', weight: 4 },
    { fill: 'rgba(233,240,244,0.95)', weight: 3 },
    { fill: 'rgba(207,222,233,0.9)', weight: 2 },
    { fill: 'rgba(228,206,166,0.85)', weight: 1 }
  ].forEach(function (t) { for (var i = 0; i < t.weight; i++) TONES.push(t.fill); });

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = matchMedia('(max-width: 560px)').matches;

  function makePetal(opts) {
    var p = document.createElement('span');
    p.className = 'petal' + (opts.className ? ' ' + opts.className : '');
    p.setAttribute('aria-hidden', 'true');
    p.innerHTML = PETAL_SVG;
    var size = opts.size;
    p.style.width = size + 'px';
    p.style.height = (size * 1.2) + 'px';
    p.querySelector('path').setAttribute('fill', TONES[Math.floor(Math.random() * TONES.length)]);
    var svg = p.querySelector('svg');
    svg.style.animationDuration = (2.2 + Math.random() * 2.6) + 's';
    svg.style.animationDelay = (-Math.random() * 4) + 's';
    return p;
  }

  /* ---- ambient drift: one full-screen canvas, recycled particles ----
     Each petal is a plain object updated per rAF; off-screen petals are
     respawned, never destroyed. Three depth tiers give parallax (pointer
     lerp) and scale/alpha variation. Petal sprites are pre-rendered to
     offscreen canvases so the draw loop is just drawImage + rotate. */
  function initCanvasPetals() {
    var canvas = document.createElement('canvas');
    canvas.id = 'petal-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:6;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;

    function resize() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    // pre-rendered petal sprites, one per tone
    var sprites = TONES.map(function (tone) {
      var s = document.createElement('canvas');
      s.width = 40; s.height = 48;
      var c = s.getContext('2d');
      c.scale(2, 2);
      c.beginPath();
      c.moveTo(10, 1);
      c.bezierCurveTo(15.5, 4.5, 18.5, 11, 10, 23);
      c.bezierCurveTo(1.5, 11, 4.5, 4.5, 10, 1);
      c.closePath();
      c.fillStyle = tone;
      c.fill();
      return s;
    });

    var COUNT = mobile ? 12 : 26;
    var DEPTH = [
      { v: 34, size: 15, alpha: 0.55, par: 26 },
      { v: 24, size: 11, alpha: 0.4,  par: 14 },
      { v: 16, size: 8,  alpha: 0.28, par: 7 }
    ];
    var petals = [];
    function spawn(p, fresh) {
      p.depth = p.depth != null ? p.depth : petals.length % 3;
      var d = DEPTH[p.depth];
      p.x = Math.random() * W;
      p.y = fresh ? Math.random() * H : -30 - Math.random() * 40;
      p.size = d.size * (0.75 + Math.random() * 0.5);
      p.vy = d.v * (0.8 + Math.random() * 0.5);
      p.vx = 4 + Math.random() * 10;
      p.swayAmp = 14 + Math.random() * 22;
      p.swayFreq = 0.4 + Math.random() * 0.5;
      p.phase = Math.random() * Math.PI * 2;
      p.rot = Math.random() * Math.PI * 2;
      p.vr = (Math.random() - 0.5) * 1.4;
      p.alpha = d.alpha * (0.8 + Math.random() * 0.4);
      p.sprite = sprites[Math.floor(Math.random() * sprites.length)];
      return p;
    }
    for (var i = 0; i < COUNT; i++) petals.push(spawn({ depth: i % 3 }, true));

    // pointer parallax (lerped), desktop only
    var ptx = 0, pty = 0, px = 0, py = 0;
    if (!mobile && matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mousemove', function (e) {
        ptx = (e.clientX / W - 0.5) * -1;
        pty = (e.clientY / H - 0.5) * -1;
      }, { passive: true });
    }

    var last = performance.now();
    function frame(now) {
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;
      px += (ptx - px) * 0.05;
      py += (pty - py) * 0.05;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < petals.length; i++) {
        var p = petals[i];
        p.y += p.vy * dt;
        p.x += p.vx * dt;
        p.phase += p.swayFreq * dt * Math.PI;
        p.rot += p.vr * dt;
        if (p.y > H + 40 || p.x > W + 80) spawn(p, false);
        var d = DEPTH[p.depth];
        var dx = p.x + Math.sin(p.phase) * p.swayAmp + px * d.par;
        var dy = p.y + py * d.par * 0.6;
        ctx.save();
        ctx.translate(dx, dy);
        ctx.rotate(p.rot + Math.sin(p.phase) * 0.5);
        ctx.globalAlpha = p.alpha;
        ctx.drawImage(p.sprite, -p.size / 2, -p.size * 0.6, p.size, p.size * 1.2);
        ctx.restore();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---- one-shot petals (bursts and hover falls) ---- */
  function spawnBurst(host, cx, cy, n) {
    for (var i = 0; i < n; i++) {
      var p = makePetal({ size: 7 + Math.random() * 6, className: 'petal-burst' });
      p.style.left = cx + 'px';
      p.style.top = cy + 'px';
      var ang = Math.random() * Math.PI * 2;
      var dist = 30 + Math.random() * 55;
      p.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      p.style.setProperty('--dy', (Math.sin(ang) * dist * 0.6 + 40 + Math.random() * 30).toFixed(0) + 'px');
      p.style.setProperty('--dr', ((Math.random() - 0.5) * 240).toFixed(0) + 'deg');
      p.style.animationDuration = (1.6 + Math.random() * 1.2) + 's';
      p.addEventListener('animationend', function (e) { e.target.closest('.petal').remove(); });
      host.appendChild(p);
    }
  }

  function spawnFalls(host, n) {
    for (var i = 0; i < n; i++) {
      var p = makePetal({ size: 8 + Math.random() * 7, className: 'petal-hoverfall' });
      p.style.left = (8 + Math.random() * 84) + '%';
      p.style.top = '-24px';
      p.style.setProperty('--fallh', (host.offsetHeight * (0.35 + Math.random() * 0.45)).toFixed(0) + 'px');
      p.style.setProperty('--swayh', ((Math.random() - 0.5) * 60).toFixed(0) + 'px');
      p.style.animationDuration = (1.8 + Math.random() * 1.4) + 's';
      p.style.animationDelay = (Math.random() * 0.5) + 's';
      p.addEventListener('animationend', function (e) { e.target.closest('.petal').remove(); });
      host.appendChild(p);
    }
  }

  /* ---- self-drawing branches with blossom bursts ---- */
  function initBranches() {
    var branches = document.querySelectorAll('.bloom-branch');
    if (!branches.length) return;
    if (reduced) {
      branches.forEach(function (b) { b.classList.add('drawn', 'no-anim'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var branch = e.target;
        branch.classList.add('drawn');
        io.unobserve(branch);
        var host = branch.parentElement;
        var pts = branch.getAttribute('data-art-points');

        if (branch.classList.contains('has-art')) {
          // ambient living painting: fade the still in, hand off to the
          // swaying clip as soon as it can play — no staged assembly.
          // Mobile plays too: the clips are small and rest offscreen.
          branch.classList.add('art-in');
          var live = branch.querySelector('.bb-live');
          if (live) {
            live.muted = true;
            if (!live.src) live.src = live.getAttribute('data-src');
            live.addEventListener('playing', function () {
              branch.classList.add('live');
            }, { once: true });
            var pr = live.play();
            if (pr && pr.catch) pr.catch(function () {});
          }
        } else {
          var blooms = branch.querySelectorAll('.bb-bloom');
          blooms.forEach(function (bloom, i) {
            setTimeout(function () {
              var br = bloom.getBoundingClientRect();
              var hr = host.getBoundingClientRect();
              spawnBurst(host, br.left - hr.left + br.width / 2, br.top - hr.top + br.height / 2, 4);
            }, 1700 + i * 450 + 600);
          });
        }
      });
    }, { threshold: 0.35 });
    branches.forEach(function (b) { io.observe(b); });
  }

  /* ---- corner flourishes appear on first sight ---- */
  function initFlourishes() {
    var flourishes = document.querySelectorAll('.bloom-flourish');
    if (!flourishes.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      flourishes.forEach(function (f) { f.classList.add('drawn', 'no-anim'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('drawn');
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    flourishes.forEach(function (f) { io.observe(f); });
  }

  /* ---- hero entrance ---- */
  function initHero() {
    if (!reduced) {
      var hero = document.querySelector('.hero-content');
      if (hero) hero.classList.add('hero-enter');
    }
    // art-mode hero: the painting comes alive shortly after load
    var artHero = document.querySelector('.hero-cine.art-mode');
    if (artHero && !reduced && !mobile) {
      var hv = artHero.querySelector('.hero-art-live');
      if (hv) {
        setTimeout(function () {
          hv.muted = true;
          if (!hv.src) hv.src = hv.getAttribute('data-src');
          hv.addEventListener('playing', function () {
            artHero.classList.add('live');
          }, { once: true });
          var pr = hv.play();
          if (pr && pr.catch) pr.catch(function () {});
        }, 2200);
      }
    }
  }

  /* ---- per-character text reveals (hand-rolled SplitText) ---- */
  function splitChars(el) {
    var label = el.textContent.replace(/\s+/g, ' ').trim();
    el.setAttribute('aria-label', label);
    var wrap = document.createElement('span');
    wrap.className = 'chars';
    wrap.setAttribute('aria-hidden', 'true');
    while (el.firstChild) wrap.appendChild(el.firstChild);
    el.appendChild(wrap);
    var ci = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (piece) {
            if (!piece) return;
            if (/^\s+$/.test(piece)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'word';
            piece.split('').forEach(function (ch) {
              var c = document.createElement('span');
              c.className = 'char';
              c.textContent = ch;
              c.style.setProperty('--cd', (ci * 16) + 'ms');
              ci++;
              w.appendChild(c);
            });
            frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          walk(child);
        }
      });
    })(wrap);
    el.classList.add('split');
  }

  function initCharReveals() {
    if (reduced) return;
    // hero + the pinned showpiece only — cascading every section title
    // reads as slideware
    var targets = document.querySelectorAll('.hero-content h1, .petal-scrub-copy h2');
    if (!targets.length) return;
    targets.forEach(splitChars);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('chars-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    targets.forEach(function (el) {
      if (el.closest('.hero-content')) {
        setTimeout(function () { el.classList.add('chars-in'); }, 500);
      } else {
        io.observe(el);
      }
    });
  }

  /* ---- inertial smooth scroll (hand-rolled Lenis) ----
     wheel input is eased through a lerp; keyboard, touch, and anchor
     jumps stay native and resync the target on outside scrolls */
  function initSmoothScroll() {
    if (reduced || mobile || !matchMedia('(pointer: fine)').matches) return;
    if (!document.body.hasAttribute('data-smooth-wheel')) return;
    var target = window.scrollY, current = target, raf = null;
    function maxScroll() {
      return document.documentElement.scrollHeight - window.innerHeight;
    }
    // CRITICAL: the theme sets `html { scroll-behavior: smooth }`; a plain
    // scrollTo() would start the browser's own smooth animation every frame
    // and fight the lerp (the "jerky / unresponsive" failure mode). Each
    // programmatic write must be instant.
    function jumpTo(y) {
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented) return;
      var scroller = e.target.closest && e.target.closest('[data-native-scroll], textarea, select');
      if (scroller) return;
      var dy = e.deltaY;
      if (e.deltaMode === 1) dy *= 16;
      else if (e.deltaMode === 2) dy *= window.innerHeight;
      // Only ease discrete mouse-wheel notches (large, integer, infrequent
      // deltas). Precision trackpads stream many small/fractional deltas
      // with OS inertia already applied — intercepting those stacks a lerp
      // on top of the OS curve and feels laggy and broken. They scroll
      // natively.
      var isNotch = e.deltaMode !== 0 || (Math.abs(dy) >= 60 && dy === Math.round(dy));
      if (!isNotch) { target = current = window.scrollY; return; }
      e.preventDefault();
      target = Math.max(0, Math.min(maxScroll(), target + dy));
      if (!raf) { current = window.scrollY; raf = requestAnimationFrame(step); }
    }, { passive: false });
    window.addEventListener('scroll', function () {
      if (!raf && Math.abs(window.scrollY - current) > 2) {
        target = current = window.scrollY;
      }
    }, { passive: true });
    function step() {
      current += (target - current) * 0.14;
      if (Math.abs(target - current) < 0.5) {
        current = target;
        jumpTo(current);
        raf = null;
        return;
      }
      jumpTo(Math.round(current));
      raf = requestAnimationFrame(step);
    }
  }

  /* ---- scroll-scrubbed video: scroll is the playhead ---- */
  function initScrub() {
    var wrap = document.querySelector('.petal-scrub-wrap');
    if (!wrap) return;
    var video = wrap.querySelector('.petal-scrub-video');
    var copy = wrap.querySelector('.petal-scrub-copy');
    var still = wrap.querySelector('.petal-scrub-still');
    if (!video) return;
    if (reduced) {
      if (copy) copy.style.opacity = 1;
      if (still) still.style.opacity = 1;
      return;
    }
    var dur = 0;
    video.addEventListener('loadedmetadata', function () { dur = video.duration; });
    video.load();
    var ticking = false;
    var lastT = -1;
    function update() {
      ticking = false;
      var r = wrap.getBoundingClientRect();
      // do nothing while the section is far from the viewport — seeking the
      // video on unrelated scrolls stalls the decoder and janks the page
      if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
      var total = r.height - window.innerHeight;
      if (total <= 0) return;
      var prog = Math.min(1, Math.max(0, -r.top / total));
      if (dur) {
        var t = prog * (dur - 0.06);
        if (Math.abs(t - lastT) > 0.02) {
          lastT = t;
          try { video.currentTime = t; } catch (err) {}
        }
      }
      if (copy) {
        var o = prog < 0.06 ? prog / 0.06 : prog > 0.86 ? Math.max(0, (1 - prog) / 0.14) : 1;
        copy.style.opacity = o.toFixed(2);
      }
      if (still) {
        // the jar on the water fades in as the scroll settles
        var so = Math.min(1, Math.max(0, (prog - 0.7) / 0.18));
        still.style.opacity = so.toFixed(2);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---- product card hover petals ---- */
  function initHoverPetals() {
    if (reduced || mobile) return;
    document.querySelectorAll('.product-grid.sleek .product-media').forEach(function (media) {
      var last = 0;
      media.addEventListener('mouseenter', function () {
        var now = Date.now();
        if (now - last < 1400) return;
        last = now;
        spawnFalls(media, 6);
      });
    });
  }

  /* ---- pause looping paintings while offscreen (decode cost -> jank);
     [data-autostart] videos also lazy-start on first intersection ---- */
  function initVideoRest() {
    var vids = document.querySelectorAll('.bb-live, .hero-art-live, .apply-live, .card-live, .hs-live');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (!v.src) {
          if (!e.isIntersecting || !v.hasAttribute('data-autostart') || reduced) return;
          v.muted = true;
          v.src = v.getAttribute('data-src');
          // living photos sit over their poster; fade in on first frame
          v.addEventListener('playing', function () {
            v.classList.add('is-live');
          }, { once: true });
        }
        if (e.isIntersecting) {
          if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '120px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    if (!document.body.hasAttribute('data-petal-drift')) return;
    // ambient canvas petals, product-card hover petals, and band sketch
    // leaves removed by request — the living films carry the motion now
    initBranches();
    initFlourishes();
    initHero();
    initCharReveals();
    initSmoothScroll();
    initScrub();
    initVideoRest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
